import { cn } from '@/lib/utils';

/**
 * TilOurDay 모노그램 — 두 개의 고리가 무한대로 얽힌 형태.
 * 결혼반지의 인터록, 그리고 "TOD"(Til Our Day) 의 함축.
 * 완전히 SVG 라 어떤 사이즈에서도 또렷하다. 색은 currentColor 로 골드/잉크 모두 가능.
 */
export function Monogram({
  className,
  size = 32,
  withInk = false,
  style,
}: {
  className?: string;
  size?: number;
  withInk?: boolean;
  style?: React.CSSProperties;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      strokeWidth={withInk ? 1.4 : 1.2}
      className={cn('shrink-0', className)}
      style={style}
      aria-hidden
    >
      {/* 좌측 링 */}
      <ellipse cx="22" cy="32" rx="14" ry="18" />
      {/* 우측 링 */}
      <ellipse cx="42" cy="32" rx="14" ry="18" />
      {/* 중앙 작은 별 — 화려함의 한 점 */}
      <g opacity="0.9">
        <path d="M32 28 L32 36 M28 32 L36 32" strokeLinecap="round" />
      </g>
    </svg>
  );
}
